<template>
  <div class="dialog_warp">
    <div class="search_warp">
      <el-form :model="form" inline>
        <el-form-item label="弹框名称">
          <el-input v-model="form.condition"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="button">
      <el-button icon="el-icon-plus" type="primary" @click="addDialog">新增弹框</el-button>
      <el-button icon="el-icon-delete" type="danger" @click="batchDeleteDialog">批量删除</el-button>
    </div>
    <!-- 列表 -->
    <el-table class="table_warp" :data="tableData" :max-height="tableHeight"
      @selection-change="val => $handleSelectionChange(val, true)" ref="multipleTable" border>
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="name" label="弹框名称" width="100" />
      <el-table-column prop="imageUrl" label="图片" width="160">
        <template slot-scope="scope">
          <el-image v-model="scope.row.imageUrl" :src="scope.row.imageUrl" fit="contain" />
        </template>
      </el-table-column>
      <el-table-column prop="redirectUrl" label="跳转路径" min-width="200">
        <template slot-scope="scope">
          <div>{{ computedRedirectPath(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status == '0' ? '显示' : '隐藏' }}
        </template>
      </el-table-column>
      <el-table-column prop="effectiveValue" label="生效时间" min-width="150">
        <template slot-scope="scope">
          {{ computedEffectiveValue(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="updateBy" label="操作员" />
      <el-table-column prop="updateTime" label="更新时间" min-width="150" />
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" type="primary" @click="editDialog(scope.row)">修改</el-button>
          <el-button icon="el-icon-delete" type="danger" @click="handelDeleteDialog(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination @current-change="pageChange" :total="total" class="mt10"
      :current-page="form.pageIndex" :page-size="form.pageSize" layout="total, prev, pager, next, jumper" />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :before-close="done => $handleClose(done, 'editForm')"
      width="600px" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" :rules="editFormRules" label-width="80px" class="form_warp">
        <el-form-item label="弹框名称" prop="name">
          <el-input v-model.trim="editForm.name" maxLength="50" placeholder="请输入图片名称" />
        </el-form-item>
        <el-form-item label="弹框状态" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="0">显示</el-radio>
            <el-radio :label="1">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定位置" prop="location">
          <el-radio-group v-model="editForm.location">
            <el-radio :label="1">首页</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片上传" prop="imageUrl">
          <div v-if="editForm.imageUrl">
            <img :src="editForm.imageUrl" class="img" />
            <el-button icon="el-icon-edit" type="primary" @click="editImg" class="btn">修改图片</el-button>
          </div>
          <Upload v-else v-loading="uploading" ref="uploadImage" @on-success="handleImgSuccess" accept=".png,.jpg,.jpeg"
            class="mr8">
            <el-button class="upload" type="primary" size="small">
              <i class="el-icon-plus"></i>
            </el-button>
          </Upload>
        </el-form-item>
        <el-form-item label="跳转路径" prop="redirectType">
          <el-radio-group v-model="editForm.redirectType" @change="changeRedirectType">
            <el-radio v-for="item in redirectTypeList" :key="item.value" :label="item.value">{{ item.label
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单列表" v-if="editForm.redirectType == '1'" prop="redirectPath">
          <el-select v-model="editForm.redirectPath" placeholder="请选择">
            <el-option v-for="item in menuList" :key="item.id" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生姓名" v-if="editForm.redirectType == '2'" prop="doctorId">
          <el-select v-model="editForm.doctorId" filterable remote reserve-keyword placeholder="请输入医生姓名"
            :remote-method="remoteMethod" @change="doctorChange">
            <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.doctorName"
              :value="item.doctorId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址" v-if="editForm.redirectType == '3'" prop="redirectPath">
          <el-input v-model="editForm.redirectPath" maxLength="200" placeholder="请输入链接地址" />
        </el-form-item>
        <el-form-item label="生效时间" prop="effectiveType">
          <el-row style="margin-bottom:15px">
            <el-radio :label="1" v-model="editForm.effectiveType" @change="changeRadioTime">每周</el-radio>
            <el-checkbox-group v-model="weekDays">
              <el-checkbox :disabled="editForm.effectiveType != 1" v-for="item in weeks" :label="item.value"
                :value="item.value" :key="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-row>
          <el-row>
            <el-radio :label="2" v-model="editForm.effectiveType" @change="changeRadioTime"
              style="display:inline-block;margin-right:15px">自定义</el-radio>
          </el-row>
          <el-date-picker :disabled="editForm.effectiveType != 2" style="width:80%" v-model="effectiveTime" format="yyyy-MM-dd"
            type="daterange" value-format="yyyy-MM-dd" :picker-options="pickerOptions" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="弹出频率" prop="popType">
          <el-radio-group v-model="editForm.popType">
            <el-radio :label="1">弹出一次</el-radio>
            <el-radio :label="2">每次启动弹出</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="handelSave">保存</el-button>
        <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDialogList, addDialog, editDialog, getDialog, deleteDialog } from '@/api/mobile'
import Upload from '@/components/Upload/Upload'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { queryClientList, doctorInfo } from "@/api/doctor"
import { debounce, dictText, deepClone, isNull, isEmptyArray } from "@/utils/validateBase";
export default {
  name: 'DialogManage',
  components: { Upload },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      form: {
        condition: '',
        pageIndex: 1, // 当前页
        pageSize: 10, // 显示条数
      },
      total: 0, // 总条数 
      multipleSelection: [], // 被选中行
      tableData: [],
      dialogTitle: null, // 模态框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      timeStatus: null,
      uploading: false,
      uploadUrl: this.$baseUrl + '/file/upload', // 图片上传接口地址
      weeks: [
        { value: 1, label: '周一' },
        { value: 2, label: '周二' },
        { value: 3, label: '周三' },
        { value: 4, label: '周四' },
        { value: 5, label: '周五' },
        { value: 6, label: '周六' },
        { value: 7, label: '周日' }
      ],
      menuList: [
        { id: 1, label: '门诊预约', value: '/pages/deptRegister/deptRegister' },
        { id: 2, label: '在线咨询', value: '/secondPages/doctorOnlineList/doctorOnlineList' },
        { id: 3, label: '理疗预约', value: '/physio/reservationHome/reservationHome' },
        { id: 4, label: '自助续方', value: '/secondPages/selfServiceIndex/selfServiceIndex' },
        { id: 5, label: '挂号记录', value: '/secondPages/registerList/registerList' },
        { id: 6, label: '处方订单', value: '/secondPages/orderList/orderList?status=all' },
        { id: 7, label: '理疗记录', value: '/physio/reservationRecordList/reservationRecordList' },
        { id: 8, label: '我的咨询', value: '/secondPages/onlineList/onlineList' },
        { id: 9, label: '充值余额', value: '/secondPages/recharge/recharge' },
        { id: 10, label: '优惠券列表', value: '/secondPages/couponList/couponList' },
      ],
      redirectTypeList: [
        { label: '菜单', value: 1 },
        { label: '医生主页', value: 2 },
        { label: '动态页面', value: 3 },
      ],
      editFormRules: {
        name: [{ required: true, message: "名称不能为空！" }],
        status: [{ required: true,message: "请选择状态"}],
        location: [{ required: true }],
        imageUrl: [{ required: true, message: "图片不能为空" }],
        redirectType: [{ required: true, message: "请选择类型" }],
        redirectPath: [{ required: true, message: "链接地址不能为空" }],
        doctorId: [{ required: true, message: "请选择医生" }],
        effectiveType: [{ required: true, message: "请选择生效时间" }],
        popType: [{ required: true, message: "请选择弹出频率" }],
      },
      effectiveTime: [],
      weekDays: [],
      doctorOptions: [],
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280;
    this.getDialogList()
  },
  computed: {
    computedRedirectPath() {
      return function (item) {
        let typeStr = dictText(item.redirectType, this.redirectTypeList)
        let str = null
        if (item.redirectType == 1) {
          str = `${typeStr}：${dictText(item.redirectPath, this.menuList)}`
        } else if (item.redirectType == 2) {
          let obj = JSON.parse(item.redirectPath)
          str = `${typeStr}：${obj.doctorName}`
        } else {
          str = `${typeStr}：${item.redirectPath}`
        }
        return str
      }
    },
    computedEffectiveValue() {
      return function (item) {
        let effectiveValue = isNull(item.effectiveValue) ? null : JSON.parse(item.effectiveValue)
        if (item.effectiveType == 1) {
          let week = []
          effectiveValue.weekDays.forEach(v => {
            week.push(dictText(v, this.weeks))
          })
          return week.join(',')
        } else {
          return `${effectiveValue.startDate} ~ ${effectiveValue.endDate}`
        }
      }
    }
  },
  methods: {
    addDialog() {
      this.dialogTitle = '新增弹框'
      this.editForm = {
        name: null,
        status: null,
        location: 1,
        imageUrl: null,
        redirectType: null,
        redirectPath: null,
        doctorId: null,
        doctorName: null,
        effectiveType: null,
        popType: null
      }
      this.weekDays = []
      this.doctorOptions = []
      this.effectiveTime = []
      this.dialogVisible = true
    },
    batchDeleteDialog() {
      let ids = []
      if (isEmptyArray(this.multipleSelection)) {
        return this.$message.warning('请选择要删除的项')
      }
      this.multipleSelection.forEach(item => {
        ids.push(item.id)
      })
      this.$confirm('确认删除该图片？').then(_ => { this.deleteDialog(ids) }).catch(_ => { });
    },
    handelDeleteDialog(row) {
      this.$confirm('确认删除该图片？').then(_ => { this.deleteDialog(row.id) }).catch(_ => { });
    },
    async deleteDialog(ids) {
      let { code } = await deleteDialog(ids)
      if (code == 200) {
        this.$message.success('删除成功')
        this.getDialogList()
      }
    },
    async getDialogList() {
      let params = { ...this.form }
      let { code, data } = await getDialogList(params)
      if (code === 200) {
        this.tableData = data.records
        this.total = data.total
      }
    },
    handleSearch() {
      this.form.pageIndex = 1
      this.getDialogList()
    },
    changeRedirectType(val) {
      this.doctorOptions = []
      this.editForm.redirectPath = null
      if (val == 2) {
        this.$set(this.editForm, 'doctorId', '')
        this.editForm.doctorName = null
      }
    },
    // 图片上传成功的函数
    handleImgSuccess(data) {
      this.uploading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(uploadRes => {
        this.uploading = false
        if (uploadRes.errorCode == '0000') {
          this.editForm.imageUrl = uploadRes.data[0].fullPathUrl
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.uploading = false;
        this.$message.error('上传失败')
      })
    },
    // 清除图片地址，显示上传图片
    editImg() {
      this.editForm.imageUrl = null;
    },
    changeRadioTime(val) {
      if (val == 1) {
        this.effectiveTime = []
      } else {
        this.weekDays = []
      }
    },
    remoteMethod: debounce(async function (query) {
      let { code, rows } = await queryClientList({ searchValue: query, pageSize: 100, pageNum: 1 })
      if (code === 200) {
        this.doctorOptions = rows
      }
    }, 300, true),
    handelSave() {
      this.$refs['editForm'].validate(async (valid) => {
        if (valid) {
          let params = { ...this.editForm }
          if (params.redirectType == 2) {
            let obj = { doctorId: params.doctorId, doctorName: params.doctorName }
            params.redirectPath = JSON.stringify(obj)
          }
          if (params.effectiveType == 1) {
            params.effectiveValue = JSON.stringify({weekDays:this.weekDays})
          } else if (params.effectiveType == 2) {
            let obj = { startDate: this.effectiveTime[0], endDate: this.effectiveTime[1] }
            params.effectiveValue = JSON.stringify(obj)
          }
          if (isNull(params.id)) {
            let { code } = await addDialog(params)
            if (code == 200) {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.getDialogList()
            }
          } else {
            let { code } = await editDialog(params)
            if (code == 200) {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.getDialogList()
            }
          }
        } else return false;
      })
    },
    editDialog: debounce(async function (row) {
      this.dialogTitle = "编辑弹框";
      this.doctorOptions = []
      this.editForm = {}
      this.effectiveTime = []
      this.weekDays = []
      let { code, data } = await getDialog({ pictureId: row.id })
      if (code == 200) {
        this.editForm = { ...data }
        this.$set(this.editForm, 'doctorId', null)
        this.$set(this.editForm, 'doctorName', null) 
        let obj = JSON.parse(data.effectiveValue)
        if (data.effectiveType == 1) {
          this.weekDays = obj.weekDays
        } else if (data.effectiveType == 2) {
          this.effectiveTime =  [obj.startDate,obj.endDate]
        }
        if (data.redirectType == 2) {
          let obj = JSON.parse(data.redirectPath);
          doctorInfo(obj.doctorId).then(res => {
            if (res.code == 200) {
              this.editForm.doctorName = res.data.doctorName
              this.editForm.doctorId = res.data.doctorId
              this.doctorOptions.push(res.data)
            }
          })
        }
        this.$forceUpdate()
        this.dialogVisible = true;
      }
    }, true, 800),
    doctorChange(val) {
      let info = this.doctorOptions.find(item => item.doctorId == val)
      this.editForm.doctorName = info.doctorName
      this.editForm.doctorId = val
      this.$forceUpdate()
    },
    pageChange(page){
      this.form.pageIndex = page
      this.getDialogList()
    },
    handleReset(){
      this.form.condition = ''
    }
  },
}
</script>

<style lang="less" scoped>
.dialog_warp {
  height: 100%;
  overflow: auto;

  .search_warp {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table_warp {
    margin-top: 16px;
  }
}

.el-iamge {
  width: auto;
  height: 100px;
  margin-top: 5px;
}

.img {
  width: 200px;
  height: auto;
  display: block;
}

.btn {
  margin-top: 5px;
}

.upload {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 2px;
  border: 1px dashed #D3D3D5;
  background-color: #FFF;
  color: #9AA0A8;
}
.form_warp{
  max-height: 550px;
  overflow: auto;
  padding-right: 8px;
}
</style>